module.exports = __webpack_public_path__ + "static/img/ic_launcher_round.2289b4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_launcher_round.png
// module id = apV+
// module chunks = 4